import { combineReducers } from "@reduxjs/toolkit";
import userContext from "../../security/state/user-slice";
import adminUserContext from "../../admin/state/users/admin-slice";
import implementationSpecialistClientsContext from "../../implementation-specialist/state/clients/implementation-clients-slice";
import metaData from "../../meta-data/state/meta-data-slice";

const adminReducer = combineReducers({
  adminUserContext: adminUserContext,
});

const implementationReducer = combineReducers({
  implementationSpecialistClient: implementationSpecialistClientsContext,
});

const rootReducer = combineReducers({
  userContext: userContext,
  adminContext: adminReducer,
  implementationContext: implementationReducer,
  metaData: metaData,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
